import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(
    private http: HttpClient
  ) { }

  createEmployee(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/employee/create', JSON.stringify(item), {withCredentials: true});
  }
}
